export const zIndex = {
  header: 10,
  headerButtons: 14,
  overlayNav: 12,
  overlayNavButtons: 13,
  modal: 15,
  cookieBar: 28,
  pageTransitionMask: 30,
}
